export default __webpack_public_path__ + "static/media/ketupak-open.c8481895.png";